import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeService } from '../../../../services/home.service';
import { Item } from '../../../../interfaces/item';
import { Stockitem } from '../../../../interfaces/stockitem';
import { LanguageServiceService } from '../../../../services/language-service.service';
import { LogoutService } from '../../../Authentication/auth/logout.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Governorate } from '../../../../interfaces/governorate';
import { GovernoratesService } from '../../../../services/governorates.service';
import { City } from '../../../../interfaces/city';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { PointOfSaleService } from '../../../../services/pos';
import e from 'express';
import { BrandService } from '../../../../services/brandservice';


@Component({
  selector: 'app-allbrands',
  templateUrl: './allbrands.component.html',
  styleUrl: './allbrands.component.scss'
})
export class AllbrandsComponent {


  allData: Stockitem[] = [];
  totalItems = 0;

  isAr: boolean = localStorage.getItem("language") == "ar";
  displayedColumns: string[] = ['brand_logo', "brandname_en", 'brandname_ar', 'brand_description_en', 'brand_description_ar', 'delete']

  imageURL = '/assets/Home.png';
  contentReady: boolean = true;
  noData: boolean = false;

  id?: string;

  itemId?: string;
  stockTotal?: string;

  isMobile: boolean = false;

  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  searchKey: string = '';
  cartItems: any[] = [];
  cartItemCount: number = 0;
  stockImageId!: any;
  addImage: boolean = false;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,

    private _brand: BrandService,
    private deviceService: DeviceDetectorService,
    private _userService: UserService,

  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();



    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";



        this.getAllbrands(localStorage.getItem('posId'), 10, 1);



      },
      error: (error) => console.error(error),
    });


  }
  // Properties for image upload
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  selectedBrandId: string | null = null;

  // Handle file selection with preview
  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.[0]) {
      this.selectedFile = input.files[0];

      // Create preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  // Submit the uploaded image
  submitImage(): void {
    if (!this.selectedFile || !this.selectedBrandId) return;

    const formData = new FormData();
    formData.append('image', this.selectedFile);
    formData.append('brand_id', this.selectedBrandId);

    // Call your service to upload
    // this.brandService.uploadLogo(formData).subscribe({
    //   next: () => {
    //     this.close();
    //     this.refreshData(); // Refresh table data
    //   },
    //   error: (err) => console.error(err)
    // });
  }

  // Open image upload modal for specific brand
  openAddImage(brandId: string): void {
    this.closeActionDropdowns();
    this.selectedBrandId = brandId;
    this.selectedFile = null;
    this.imagePreview = null;
    this.addImage = true;
  }

  // Close modal and reset
  close(): void {
    this.addImage = false;
    this.selectedFile = null;
    this.imagePreview = null;
    this.selectedBrandId = null;
  }
  fixurl(imagePath: string | null): string {
    if (!imagePath) return '/assets/Home.png';
    if (imagePath.startsWith('http')) return imagePath;
    return `https://backendproduction.blueboxpet.com/storage/app/public//${imagePath}`;
  }

  onBrandImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    image.src = '/assets/Home.png';
  }

  deleteitem(id: string) {
    this.closeActionDropdowns();

    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._brand.delete(id).subscribe({
          next: (res) => {
            this.getAllbrands(localStorage.getItem('posId'), 10, 1);
          },
          error: () => {
            this.contentReady = false;
          },
        });
      }
    });

  }
  getAllbrands(warehouse: any, perpage: any, page: any) {
    this.contentReady = true;

    this._brand.getAll(warehouse, perpage, page).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.stockTotal = data['total'];
        this.totalItems = data['last_page'];
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }



  onPaginateChange(event: PageEvent) {
    const newPage = event.pageIndex + 1;
    this.getAllbrands(localStorage.getItem('posId'), 10, newPage);
  }
  edit(itemobj: any) {
    this.closeActionDropdowns();
    this.router.navigate(['/createbrand'], { queryParams: itemobj });
  }
  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2); // Getting last two digits of the year
    return `${day}-${month}-${year}`;
  }

  private closeActionDropdowns(): void {
    document.querySelectorAll('.bb-action-dropdown .dropdown-toggle, .bb-action-dropdown [data-bs-toggle="dropdown"]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });

    document.querySelectorAll('.bb-action-dropdown .dropdown-menu.show').forEach((menu) => {
      menu.classList.remove('show');
    });

    document.querySelectorAll('.bb-action-dropdown.show').forEach((dropdown) => {
      dropdown.classList.remove('show');
    });
  }


}
